export enum BannerType {
  Info,
  Warning,
  Error,
}
